/* unplugin-vue-components disabled */import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=0f31a217&lang=scss"

const __exports__ = script;

export default __exports__